import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import toast from "../ui/toast";
import ReCAPTCHA from "react-google-recaptcha";
import "./FormLocalSearch.css";
import IconMaps from "./assets/icon-maps.png";
import IconGoogle from "./assets/icon-google.png";
import ModalMoreInfoSerp from "../../App/SearchLocationChecker/ModalMoreInfoSerp";
import useLang from "../../i18n/useLang";
import content from "./content";

export const LocalSearch = ({ onLocalSearchSubmit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalBusinessInfo, setModalBusinessInfo] = useState(false);
  const [searchObj, setSearchObj] = useState({});
  const [isSA, setIsSA] = useState(false);
  const recaptchaRef = React.useRef();
  const location = useLocation();
  const lang = useLang();
  const t = content[lang];

  const [values, setValues] = useState({
    SearchTerm: "",
    Location: "",
    Country: t.countries[0].value,
    SearchType: "google",
  });

  useEffect(() => {
    if (location.search.includes("access=localranker")) {
      setIsSA(true);
    }
  }, [location.search]);

  const handleChange = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  const onSubmit = async () => {
    try {
      const tokenCaptcha = isSA ? true : await recaptchaRef.current.executeAsync();
      if (!tokenCaptcha) {
        toast.warning(t.captchaWarning);
        return;
      }

      setIsLoading(true);
      const search = {
        searchTerm: values.SearchTerm,
        location: values.Location,
        country: values.Country,
        searchType: values.SearchType,
      };
      setSearchObj(search);

      if (isSA) {
        await onLocalSearchSubmit(search);
      } else {
        setModalBusinessInfo(true);
      }
    } catch (e) {
      console.log(e);
      recaptchaRef.current?.reset();
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabled =
    !values.SearchTerm ||
    !values.Location ||
    !values.Country ||
    !values.SearchType;

  return (
    <div className="serp-form">
      <div className="serp-form__card">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="serp-form__grid">
            <div className="serp-form__field">
              <label className="serp-form__label">{t.searchTermLabel}</label>
              <input
                className="serp-form__input"
                autoFocus
                placeholder={t.searchTermPlaceholder}
                value={values.SearchTerm}
                onChange={(e) => handleChange("SearchTerm", e.target.value)}
              />
            </div>
            <div className="serp-form__field">
              <label className="serp-form__label">{t.locationLabel}</label>
              <input
                className="serp-form__input"
                placeholder={t.locationPlaceholder}
                value={values.Location}
                onChange={(e) => handleChange("Location", e.target.value)}
              />
            </div>
            <div className="serp-form__field">
              <label className="serp-form__label">{t.countryLabel}</label>
              <select
                className="serp-form__select"
                value={values.Country}
                onChange={(e) => handleChange("Country", e.target.value)}
              >
                {t.countries.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="serp-form__field">
              <label className="serp-form__label">{t.searchTypeLabel}</label>
              <div className="serp-form__toggle">
                <button
                  type="button"
                  className={`serp-form__toggle-btn${values.SearchType === "google" ? " serp-form__toggle-btn--active" : ""}`}
                  onClick={() => handleChange("SearchType", "google")}
                >
                  <img src={IconGoogle} alt="" width="14" />
                  Google
                </button>
                <button
                  type="button"
                  className={`serp-form__toggle-btn${values.SearchType === "maps" ? " serp-form__toggle-btn--active" : ""}`}
                  onClick={() => handleChange("SearchType", "maps")}
                >
                  <img src={IconMaps} alt="" width="14" />
                  Maps
                </button>
              </div>
            </div>
          </div>

          <ReCAPTCHA
            sitekey="6LcLC9UZAAAAAOY_vgaU__i3Qhs1tmHtvbibjD2V"
            size="invisible"
            ref={recaptchaRef}
          />

          <button
            onClick={onSubmit}
            className={`serp-form__submit${isLoading ? " serp-form__submit--loading" : ""}`}
            type="submit"
            disabled={isDisabled || isLoading}
          >
            {isLoading ? t.loading : t.submit}
          </button>
        </form>
      </div>

      <ModalMoreInfoSerp
        modalBusinessInfo={modalBusinessInfo}
        setModalBusinessInfo={setModalBusinessInfo}
        onLocalSearchSubmit={onLocalSearchSubmit}
        location={searchObj}
      />
    </div>
  );
};

export default withRouter(LocalSearch);
